import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from "./components/Root/App";
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
